<div id="js-popover-overlay" style="
	height:{{this.height}}px;
	width:{{this.width}}px;
	padding: {{this.padding}}px;">
</div>
